import { config } from '@/config';

export const FUND_DOCUMENT_CATEGORY_OPTIONS = [
  { label: 'Offering Documents', value: 'offeringDocuments' },
  { label: 'Subscription Documents', value: 'subscriptionDocuments' },
  { label: 'Risk Disclosure Acknowledgements', value: 'riskDisclosureDocuments' },
  { label: 'Marketing', value: 'marketingDocuments' },
  { label: 'Audits', value: 'audits' },
] as const;

export type FundDocumentCategoryKey = (typeof FUND_DOCUMENT_CATEGORY_OPTIONS)[number]['value'];

export const FUND_DOCUMENT_CATEGORY_LABELS: Record<FundDocumentCategoryKey, string> =
  Object.fromEntries(FUND_DOCUMENT_CATEGORY_OPTIONS.map((o) => [o.value, o.label])) as Record<
    FundDocumentCategoryKey,
    string
  >;

export const FUND_DOCUMENT_ADD_DENIED_MESSAGE =
  'You do not have permission to add documents to this fund (FundManage).';

export const FUND_DOCUMENT_REPLACE_DENIED_MESSAGE =
  'You do not have permission to replace documents on this fund (FundManage).';

export const FUND_DOCUMENT_DELETE_DENIED_MESSAGE =
  'You do not have permission to delete documents from this fund (FundManage).';

export const FUND_DOCUMENT_NOTES_MAX_LENGTH = 5000;
export const FILE_PROPAGATION_WAIT_MS = 6000;

// Keep in sync with apps/api/src/contexts/file/modules/file/domain/constants/index.ts on the BE.
// Binary MB so formatFileSize (which uses 1024-based units) renders "5.0 MB".
export const FUND_DOCUMENT_MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024;

export const COVER_IMAGE_ID = config.IS_DEVELOPMENT
  ? 'a933aa2d-bedc-4bf4-bdcf-b090ce583aca'
  : 'fefa8d3d-8cef-4c10-b980-214c4420561b';
